export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // file:// and older browsers may deny the async Clipboard API. A copy command triggered
    // by the operator's click still works there without granting clipboard read permission.
    const focused = document.activeElement;
    const field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "");
    field.style.cssText = "position:fixed;left:-9999px;top:0";
    document.body.appendChild(field);
    field.select();
    try { return document.execCommand("copy"); }
    catch { return false; }
    finally { field.remove(); focused?.focus({ preventScroll: true }); }
  }
}
